import { PrizmLanguageCron } from '../../interfaces';

export const PRIZM_ENGLISH_CRON: PrizmLanguageCron = {
  cron: {
    title: 'Cron',
    submitText: 'Apply',
    resetText: 'Cancel',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    chooseYearLabel: 'Type the year',
    indefinitelyLabel: 'Indefinitely',
    switcherTitles: {
      second: 'Seconds',
      minute: 'Minutes',
      hour: 'Hours',
      day: 'Days',
      month: 'Months',
      year: 'Years',
    },

    every: 'Every',
    to: 'to',
    at: 'At',

    second: 'second',
    secondSince: 'second since',
    selectedSecond: 'Selected second (select one or more)',
    everySecond: 'Every second',
    everySecondFrom: 'Every second from',

    minute: 'minute',
    minuteSince: 'minute since',
    selectedMinute: 'Selected minute (select one or more)',
    everyMinute: 'Every minute',
    everyMinuteFrom: 'Every minute from',

    hour: 'hour',
    hourSince: 'hour since',
    selectedHour: 'Selected hour (select one or more)',
    everyHour: 'Every hour',
    everyHourFrom: 'Every hour from',

    day: 'day',
    everyDay: 'Every day',
    daySince: 'day since',
    dayOfMonth: 'day of the month',
    ofMonth: 'of the month',

    specificWeekDays: 'On specific days of the week (select one or more)',
    specificMonthDays: 'On specific days of the month (select one or more)',

    last_dayOfMonth: 'Last day of the month',
    last_workingDayOfMonth: 'Last working day of the month',
    last_dayOfWeek: 'Last',
    last_ofMonth: 'of the month',
    last_day: 'On the last',
    untilEndOfMonth: 'day(s) before the end of the month',

    nearestWorkingDay: 'The nearest working day (Monday - Friday) to the',
    nearestToDayOfMonth: 'of the month',

    month: 'month',
    monthSince: 'month since',
    selectedMonth: 'Selected month (select one or more)',
    everyMonth: 'Every month',
    everyMonthFrom: 'Every month from',

    year: 'year',
    yearSince: 'year since',
    selectedYear: 'Selected year (select one or more)',
    everyYear: 'Every year',
    everyYearFrom: 'Every year from',

    weekDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortWeekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },
};
